
import * as THREE from './pbspa-three.module.min.js';
import {GLTFLoader} from './pbspa-GLTFLoader.js';
import {DRACOLoader} from './pbspa-DRACOLoader.js';

export {THREE};


export function createStudio(canvas){
 let renderer;
 try{renderer=new THREE.WebGLRenderer({canvas,antialias:true,alpha:true,powerPreference:'high-performance'});}
 catch(e){return null;}
 renderer.setPixelRatio(Math.min(devicePixelRatio,1.75));
 renderer.outputColorSpace=THREE.SRGBColorSpace;
 renderer.toneMapping=THREE.ACESFilmicToneMapping;
 renderer.toneMappingExposure=.88;
 renderer.shadowMap.enabled=true;renderer.shadowMap.type=THREE.PCFSoftShadowMap;

 const scene=new THREE.Scene(),camera=new THREE.PerspectiveCamera(30,1,.1,100);
 scene.environment=studioEnvironment(renderer);

 const key=new THREE.DirectionalLight(0xfff6ec,1.75);
 key.position.set(-2.8,5.6,3.6);key.castShadow=true;key.shadow.mapSize.set(2048,2048);
 key.shadow.camera.left=-2.6;key.shadow.camera.right=2.6;key.shadow.camera.top=2.6;key.shadow.camera.bottom=-2.6;
 key.shadow.radius=3.5;key.shadow.bias=-.00035;key.shadow.normalBias=.012;scene.add(key);
 const rim=new THREE.DirectionalLight(0xdfeeff,1.15);rim.position.set(3.6,2.6,-3.6);scene.add(rim);
 const fill=new THREE.DirectionalLight(0xffffff,.42);fill.position.set(1.2,1.6,4.4);scene.add(fill);
 
 const top=new THREE.DirectionalLight(0xffffff,.55);top.position.set(.2,6,-.6);scene.add(top);
 scene.add(new THREE.HemisphereLight(0xf4f8ff,0x191b1e,.5));

 const floor=new THREE.Mesh(new THREE.PlaneGeometry(24,24),new THREE.ShadowMaterial({opacity:.46}));
 floor.rotation.x=-Math.PI/2;floor.receiveShadow=true;scene.add(floor);
 const pool=new THREE.Mesh(new THREE.PlaneGeometry(9,9),new THREE.MeshBasicMaterial({map:glowTexture(),transparent:true,opacity:.3,depthWrite:false}));
 pool.rotation.x=-Math.PI/2;pool.position.y=.002;scene.add(pool);

 return {renderer,scene,camera,floor,pool};
}



export const MODEL_FILE={'630L-115':'630L','630L-230':'630L','743L-230':'743L','744B-230':'744B'};
export const FINISH={
 '630L-115':{shell:'silver',cabinet:'black'},
 '630L-230':{shell:'silver',cabinet:'black'},
 '743L-230':{shell:'cosmic',cabinet:'black'},
 '744B-230':{shell:'silver',cabinet:'grey'}};
export const layoutFor=code=>({file:MODEL_FILE[code]||'743L',...(FINISH[code]||FINISH['743L-230'])});


export const assetURL=p=>(window.PB_ASSETS&&window.PB_ASSETS[p.split('/').pop()])||p;
const draco=new DRACOLoader().setDecoderPath(window.PB_DRACO_PATH||'');
const loader=new GLTFLoader().setDRACOLoader(draco);
const models=new Map();

function loadGLB(url){
 if(!models.has(url))models.set(url,new Promise((res,rej)=>loader.load(url,g=>res(g),undefined,rej)));
 return models.get(url);
}


export function prefetchSpa(code,base='assets/',renderer=null){
 const {file,shell,cabinet}=layoutFor(code);
 photoTexture(`${base}lx-acrylic-${shell}.webp`,renderer);
 photoTexture(`${base}lx-cabinet-${cabinet}.webp`,renderer);
 return loadGLB(assetURL(`${base}lx-spa-${file}.glb`)).catch(()=>null);
}


function dress(root,{shellMap,cabinet,renderer,base='assets/'}){
 const aniso=renderer?renderer.capabilities.getMaxAnisotropy():1;
 const grain=photoTexture(`${base}lx-cabinet-${cabinet==='black'?'black':'grain'}.webp`,renderer),
       bump=photoTexture(`${base}lx-cabinet-bump.webp`,renderer,true);
 const M={};
 
 M.acrylic=new THREE.MeshPhysicalMaterial({color:0xffffff,map:shellMap,roughness:.16,metalness:0,
  clearcoat:1,clearcoatRoughness:.03,envMapIntensity:1.35,vertexColors:true,
  specularIntensity:.6,sheen:.18,sheenRoughness:.55,sheenColor:new THREE.Color(0xe7eef4)});
 
 M.polysteel=new THREE.MeshStandardMaterial({color:0xffffff,map:grain,bumpMap:bump,bumpScale:cabinet==='black'?.035:.02,
  roughness:cabinet==='black'?.7:.8,metalness:0,envMapIntensity:cabinet==='black'?1.1:.7,vertexColors:true});
 M.shadow=new THREE.MeshStandardMaterial({color:0x0b0c0e,roughness:.9,metalness:0,vertexColors:true});
 
 
 
 M.jetface=new THREE.MeshPhysicalMaterial({color:0x6e747c,roughness:.34,metalness:.35,clearcoat:.45,clearcoatRoughness:.22,envMapIntensity:1.7});
 M.jetfin=new THREE.MeshStandardMaterial({color:0xc9ced4,roughness:.26,metalness:1,envMapIntensity:1.8});
 M.stainless=new THREE.MeshStandardMaterial({color:0xe9edf1,roughness:.1,metalness:1,envMapIntensity:2.1});
 M.chrome=new THREE.MeshStandardMaterial({color:0xf3f5f8,roughness:.05,metalness:1,envMapIntensity:2.4});
 M.bore=new THREE.MeshStandardMaterial({color:0x17191d,roughness:.62,metalness:.25,envMapIntensity:1.2});
 M.suction=new THREE.MeshPhysicalMaterial({color:0x6d7177,roughness:.45,metalness:0,clearcoat:.5,clearcoatRoughness:.3});
 M.graphite=new THREE.MeshPhysicalMaterial({color:0x2b2e32,roughness:.5,metalness:0,clearcoat:.35,clearcoatRoughness:.4});
 M.pillow=new THREE.MeshPhysicalMaterial({color:0x2c3035,roughness:.5,metalness:0,clearcoat:.3,clearcoatRoughness:.38,envMapIntensity:1.3,vertexColors:true});
 M.insert=new THREE.MeshPhysicalMaterial({color:0x5a5f66,roughness:.55,metalness:0,clearcoat:.2,clearcoatRoughness:.4});
 M.pleat=new THREE.MeshStandardMaterial({color:0xe9e5da,roughness:.92,metalness:0});
 M.cap=new THREE.MeshPhysicalMaterial({color:0x1d57b8,roughness:.4,metalness:0,clearcoat:.4});
 M.lens=new THREE.MeshPhysicalMaterial({color:0xe6f0f6,roughness:.05,metalness:0,clearcoat:1,
  emissive:0x6fc8ff,emissiveIntensity:.08});
 
 const face=photoTexture(`${base}lx-keypad-face.webp`,renderer);face.anisotropy=aniso;
 M.keypad=new THREE.MeshPhysicalMaterial({color:0xffffff,map:face,roughness:.3,metalness:0,
  clearcoat:1,clearcoatRoughness:.03,emissive:0xffffff,emissiveMap:keypadGlow(),emissiveIntensity:.04});
 M.keyglass=new THREE.MeshPhysicalMaterial({color:0x0b1112,roughness:0,metalness:0,transparent:true,opacity:.28,
  clearcoat:1,clearcoatRoughness:0,envMapIntensity:1.6});
 
 M.lid=new THREE.MeshPhysicalMaterial({color:0x4d5156,roughness:.62,metalness:0,clearcoat:.2,clearcoatRoughness:.45});
 M.water=waterMaterial();
 
 for(const k of ['jetface','jetfin','stainless','chrome','bore','suction','graphite','lens','cap','pleat','lid','insert'])
  if(M[k])M[k].side=THREE.DoubleSide;

 const pick=n=>
  n.startsWith('shell')||n.startsWith('keypadpad')?M.acrylic:
  n.startsWith('jetbore')?M.bore:n.startsWith('jetfin')?M.jetfin:n.startsWith('jetnozzle')?M.stainless:
  n.startsWith('jets')||n.startsWith('aircontrols')?M.jetface:
  n.startsWith('suction')?M.suction:n.startsWith('lens')?M.lens:
  n.startsWith('keypadbezel')||n.startsWith('waterfeature')?M.chrome:n.startsWith('keypadface')?M.keypad:
  n.startsWith('keypadglass')?M.keyglass:n.startsWith('cupled')?M.lens:
  n.startsWith('filterlid')?M.lid:
  n.startsWith('filter')||n.startsWith('skimmer')||n.startsWith('cupholders')?M.graphite:
  n.startsWith('cartridgecap')?M.cap:n.startsWith('cartridge')?M.pleat:
  n.startsWith('headrestinsert')?M.insert:n.startsWith('headrest')?M.pillow:
  n.startsWith('cabinet')||n.startsWith('post')?M.polysteel:
  n.startsWith('reveal')||n.startsWith('plinth')?M.shadow:
  n.startsWith('water')?M.water:null;
 const parts={};
 root.traverse(o=>{
  if(!o.isMesh)return;
  const m=pick(o.name);if(!m)return;
  o.material=m;o.castShadow=o.receiveShadow=!o.name.startsWith('water');
  
  if(m.vertexColors&&!o.geometry.attributes.color){o.material=m.clone();o.material.vertexColors=false;}
  const key=o.name.replace(/_\d.*$/,'').replace(/_[0-9A-Z]{4}.*$/,'');
  (parts[key]=parts[key]||[]).push(o);
 });
 
 for(const t of [grain,bump]){t.wrapS=t.wrapT=THREE.RepeatWrapping;t.repeat.set(1/.62,1/.62);t.anisotropy=aniso;}
 return {M,parts};
}


function keypadTexture(){
 const c=document.createElement('canvas');c.width=1024;c.height=428;const g=c.getContext('2d');
 const W=c.width,H=c.height,r=H/2;
 const body=new Path2D();body.moveTo(r,0);body.lineTo(W-r,0);body.arc(W-r,r,r,-Math.PI/2,Math.PI/2);body.lineTo(r,H);body.arc(r,r,r,Math.PI/2,Math.PI*1.5);
 const bg=g.createLinearGradient(0,0,0,H);bg.addColorStop(0,'#f4f6f8');bg.addColorStop(.55,'#dfe4ea');bg.addColorStop(1,'#c9d1da');
 g.fillStyle=bg;g.fill(body);
 g.save();g.clip(body);                                   // the blue sweep across the lower face
 const sw=g.createLinearGradient(0,H*.45,0,H);sw.addColorStop(0,'rgba(38,70,140,0)');sw.addColorStop(1,'rgba(38,70,140,.55)');
 g.fillStyle=sw;g.beginPath();g.moveTo(0,H*.62);g.bezierCurveTo(W*.3,H*.42,W*.7,H*.95,W,H*.6);g.lineTo(W,H);g.lineTo(0,H);g.fill();g.restore();
 // LCD
 const lx=W*.36,ly=H*.28,lw=W*.28,lh=H*.44;
 g.fillStyle='#1b2226';g.fillRect(lx-6,ly-6,lw+12,lh+12);
 const lcd=g.createLinearGradient(0,ly,0,ly+lh);lcd.addColorStop(0,'#b9c7c2');lcd.addColorStop(1,'#9fb1ab');
 g.fillStyle=lcd;g.fillRect(lx,ly,lw,lh);
 g.fillStyle='#1d2a2a';g.font='600 150px "Arial Narrow",Arial,sans-serif';g.textBaseline='middle';g.textAlign='center';
 g.fillText('102',lx+lw*.44,ly+lh*.54);g.font='600 46px Arial,sans-serif';g.fillText('°F',lx+lw*.86,ly+lh*.36);
 g.font='700 26px Arial,sans-serif';g.fillText('R',lx+lw*.08,ly+lh*.82);
 // buttons
 const btn=(x,y,label,draw)=>{
  const gr=g.createRadialGradient(x-10,y-12,4,x,y,46);gr.addColorStop(0,'#3b5fa8');gr.addColorStop(1,'#1c2f63');
  g.fillStyle='rgba(0,0,0,.25)';g.beginPath();g.arc(x+2,y+4,44,0,Math.PI*2);g.fill();
  g.fillStyle=gr;g.beginPath();g.arc(x,y,42,0,Math.PI*2);g.fill();
  g.strokeStyle='#eef2f8';g.fillStyle='#eef2f8';g.lineWidth=6;g.lineCap='round';g.lineJoin='round';draw(x,y);
  g.fillStyle='#2a3550';g.font='700 21px Arial,sans-serif';g.textAlign='center';g.fillText(label,x,y+(y<H/2?-62:66));};
 btn(W*.19,H*.33,'WARM',(x,y)=>{g.beginPath();g.moveTo(x-16,y+7);g.lineTo(x,y-9);g.lineTo(x+16,y+7);g.stroke();});
 btn(W*.19,H*.69,'COOL',(x,y)=>{g.beginPath();g.moveTo(x-16,y-7);g.lineTo(x,y+9);g.lineTo(x+16,y-7);g.stroke();});
 btn(W*.73,H*.33,'MENU',(x,y)=>{for(const d of [-10,0,10]){g.beginPath();g.moveTo(x-14,y+d);g.lineTo(x+14,y+d);g.stroke();}});
 btn(W*.86,H*.33,'JETS',(x,y)=>{g.beginPath();g.arc(x,y,12,Math.PI*.2,Math.PI*1.7);g.stroke();g.beginPath();g.arc(x,y,4,0,7);g.fill();});
 btn(W*.73,H*.69,'LIGHT',(x,y)=>{g.beginPath();g.arc(x,y-3,9,0,Math.PI*2);g.stroke();for(let k=0;k<8;k++){const a=k*Math.PI/4;g.beginPath();g.moveTo(x+Math.cos(a)*14,y-3+Math.sin(a)*14);g.lineTo(x+Math.cos(a)*19,y-3+Math.sin(a)*19);g.stroke();}});
 btn(W*.86,H*.69,'AUX',(x,y)=>{for(let k=0;k<5;k++){const a=k*Math.PI*2/5;g.beginPath();g.arc(x+Math.cos(a)*10,y+Math.sin(a)*10,3.2,0,7);g.fill();}});
 const t=new THREE.CanvasTexture(c);t.colorSpace=THREE.SRGBColorSpace;t.anisotropy=8;return t;
}
function keypadGlow(){                 // only the LCD glows, and only a little
 const c=document.createElement('canvas');c.width=256;c.height=107;const g=c.getContext('2d');
 // the display window in faceplate UVs (spa_parts.LCD over a 0.235 x 0.098 m panel)
 g.fillStyle='#000';g.fillRect(0,0,256,107);g.fillStyle='#7ea39a';g.fillRect(256*.368,107*(1-.704),256*.264,107*.388);
 const t=new THREE.CanvasTexture(c);t.colorSpace=THREE.SRGBColorSpace;return t;
}



function rippleNormals(size=256,seed=1,waves=26){
 const h=new Float32Array(size*size),rnd=(()=>{let s=seed;return()=>((s=(s*16807)%2147483647)/2147483647);})();
 const W=[];
 for(let i=0;i<waves;i++){                 // integer wave vectors keep the tile seamless
  const f=3+rnd()*11,a=rnd()*Math.PI*2;
  W.push([Math.round(Math.cos(a)*f),Math.round(Math.sin(a)*f),rnd()*6.28,1/(1+f*.35)]);}
 for(let y=0;y<size;y++)for(let x=0;x<size;x++){let v=0;for(const [a,b,p,amp] of W)v+=amp*Math.sin(2*Math.PI*(a*x+b*y)/size+p);h[y*size+x]=v;}
 const c=document.createElement('canvas');c.width=c.height=size;const g=c.getContext('2d'),img=g.createImageData(size,size);
 for(let y=0;y<size;y++)for(let x=0;x<size;x++){
  const dx=h[y*size+(x+1)%size]-h[y*size+(x-1+size)%size],dy=h[((y+1)%size)*size+x]-h[((y-1+size)%size)*size+x];
  const nx=-dx*.9,ny=-dy*.9,l=Math.hypot(nx,ny,1),i=(y*size+x)*4;
  img.data[i]=(nx/l*.5+.5)*255;img.data[i+1]=(ny/l*.5+.5)*255;img.data[i+2]=(1/l*.5+.5)*255;img.data[i+3]=255;}
 g.putImageData(img,0,0);
 const t=new THREE.CanvasTexture(c);t.wrapS=t.wrapT=THREE.RepeatWrapping;t.colorSpace=THREE.NoColorSpace;return t;
}
function waterMaterial(){
 
 const m=new THREE.MeshPhysicalMaterial({color:0xffffff,roughness:.02,metalness:0,transmission:1,thickness:.32,ior:1.333,
  attenuationColor:new THREE.Color(0xcdeee9),attenuationDistance:2.2,specularIntensity:.85,envMapIntensity:.9,
  clearcoat:.6,clearcoatRoughness:.03,side:THREE.DoubleSide,
  normalMap:rippleNormals(256,7),clearcoatNormalMap:rippleNormals(256,3)});
 m.normalMap.repeat.set(7,7);m.clearcoatNormalMap.repeat.set(11,11);
 m.normalScale.set(.1,.1);m.clearcoatNormalScale.set(.08,.08);
 return m;
}
function softDot(){
 const c=document.createElement('canvas');c.width=c.height=64;const g=c.getContext('2d');
 const r=g.createRadialGradient(32,32,2,32,32,30);r.addColorStop(0,'rgba(255,255,255,.95)');r.addColorStop(.45,'rgba(255,255,255,.5)');r.addColorStop(1,'rgba(255,255,255,0)');
 g.fillStyle=r;g.fillRect(0,0,64,64);const t=new THREE.CanvasTexture(c);return t;
}


function causticTexture(size=256){
 const waves=[],rnd=(()=>{let s=11;return()=>((s=(s*16807)%2147483647)/2147483647);})();
 for(let i=0;i<14;i++){const f=2+rnd()*6,a=rnd()*6.283;waves.push([Math.round(Math.cos(a)*f),Math.round(Math.sin(a)*f),rnd()*6.283,1/(1+f)]);}
 const acc=new Float32Array(size*size),N=size*2,k=size*.055;
 for(let j=0;j<N;j++)for(let i=0;i<N;i++){
  const x=i/N,y=j/N;let gx=0,gy=0;
  for(const [a,b,p,m] of waves){const c=Math.cos(6.2832*(a*x+b*y)+p)*m*6.2832;gx+=a*c;gy+=b*c;}
  const u=((x*size+gx*k)%size+size)%size,v=((y*size+gy*k)%size+size)%size;
  const ui=u|0,vi=v|0,fu=u-ui,fv=v-vi,u1=(ui+1)%size,v1=(vi+1)%size;
  acc[vi*size+ui]+=(1-fu)*(1-fv);acc[vi*size+u1]+=fu*(1-fv);acc[v1*size+ui]+=(1-fu)*fv;acc[v1*size+u1]+=fu*fv;}
 let mx=0;for(const v of acc)mx=Math.max(mx,v);
 const c=document.createElement('canvas');c.width=c.height=size;const g=c.getContext('2d'),img=g.createImageData(size,size);
 for(let i=0;i<acc.length;i++){const v=Math.pow(Math.min(1,acc[i]/(mx*.55)),1.6)*255;img.data[i*4]=img.data[i*4+1]=img.data[i*4+2]=v;img.data[i*4+3]=255;}
 g.putImageData(img,0,0);g.filter='blur(1px)';g.drawImage(c,0,0);
 const t=new THREE.CanvasTexture(c);t.wrapS=t.wrapT=THREE.RepeatWrapping;t.colorSpace=THREE.NoColorSpace;return t;
}

function causticShell(mat,waterY){
 const U={uCaus:{value:causticTexture()},uCausOn:{value:0},uCausT:{value:0},uWaterY:{value:waterY},uCausCol:{value:new THREE.Color(1,.98,.92)}};
 mat.onBeforeCompile=sh=>{
  Object.assign(sh.uniforms,U);
  sh.vertexShader=sh.vertexShader.replace('#include <common>','#include <common>\nvarying vec3 vCausPos;')
   .replace('#include <project_vertex>','#include <project_vertex>\nvCausPos=(modelMatrix*vec4(transformed,1.0)).xyz;');
  sh.fragmentShader=sh.fragmentShader.replace('#include <common>',
   '#include <common>\nvarying vec3 vCausPos;uniform sampler2D uCaus;uniform float uCausOn,uCausT,uWaterY;uniform vec3 uCausCol;')
   .replace('#include <dithering_fragment>',`
    if(uCausOn>0.001){
     float d=uWaterY-vCausPos.y;
     if(d>0.0){
      vec2 p=vCausPos.xz*1.35;
      float c=texture2D(uCaus,p+vec2(uCausT*.021,uCausT*.013)).r*texture2D(uCaus,p*1.31+vec2(-uCausT*.017,uCausT*.024)).r;
      float fade=smoothstep(0.0,0.06,d)*exp(-d*2.2);
      gl_FragColor.rgb+=uCausCol*c*fade*uCausOn*1.6;
     }
    }
    #include <dithering_fragment>`);
 };
 mat.customProgramCacheKey=()=>'caustic-shell';
 return U;
}


function jetCentres(group,waterY){
 const out=[],cells=new Map();
 group.updateMatrixWorld(true);
 group.traverse(o=>{
  if(!o.isMesh||!o.name.startsWith('jets'))return;
  const p=o.geometry.attributes.position,v=new THREE.Vector3();
  for(let i=0;i<p.count;i+=3){
   v.fromBufferAttribute(p,i).applyMatrix4(o.matrix);   // meshes are direct children of the group
   const k=[Math.round(v.x/.07),Math.round(v.y/.07),Math.round(v.z/.07)].join();
   const c=cells.get(k)||{x:0,y:0,z:0,n:0};c.x+=v.x;c.y+=v.y;c.z+=v.z;c.n++;cells.set(k,c);}
 });
 for(const c of cells.values())if(c.n>6){const p=new THREE.Vector3(c.x/c.n,c.y/c.n,c.z/c.n);if(p.y<waterY-.03)out.push(p);}
 return out;
}


function makeWater(group,M){
 const water=[];group.traverse(o=>{if(o.isMesh&&o.name.startsWith('water'))water.push(o);});
 if(!water.length)return null;
 const surf=water[0];surf.visible=false;surf.renderOrder=2;
 const y=new THREE.Box3().setFromObject(surf).max.y;
 const jets=jetCentres(group,y);
 const N=Math.min(900,jets.length*26),pos=new Float32Array(N*3),life=new Float32Array(N),src=new Uint16Array(N);
 for(let i=0;i<N;i++){src[i]=i%jets.length;life[i]=Math.random();}
 const geo=new THREE.BufferGeometry();geo.setAttribute('position',new THREE.BufferAttribute(pos,3));
 const dot=softDot();
 const bubbles=new THREE.Points(geo,new THREE.PointsMaterial({map:dot,size:.012,transparent:true,opacity:.6,depthWrite:false,color:0xffffff,blending:THREE.AdditiveBlending}));
 bubbles.renderOrder=3;
 const fgeo=new THREE.BufferGeometry(),fpos=new Float32Array(jets.length*3);
 jets.forEach((j,i)=>{fpos[i*3]=j.x*.9;fpos[i*3+1]=y+.004;fpos[i*3+2]=j.z*.9;});
 fgeo.setAttribute('position',new THREE.BufferAttribute(fpos,3));
 const foam=new THREE.Points(fgeo,new THREE.PointsMaterial({map:dot,size:.11,transparent:true,opacity:.3,depthWrite:false,color:0xffffff}));
 foam.renderOrder=3;
 bubbles.visible=foam.visible=false;bubbles.frustumCulled=foam.frustumCulled=false;
 group.add(bubbles,foam);
 
 let pop=null;const streams=[],splashes=[];
 group.traverse(o=>{if(o.isMesh&&o.name.startsWith('waterfeature'))pop=o;});
 const streamMat=new THREE.MeshPhysicalMaterial({color:0xffffff,roughness:.04,transmission:1,thickness:.02,ior:1.333,
  emissive:0x57b4ff,emissiveIntensity:0,clearcoat:1,clearcoatRoughness:.02});
 for(const name of ['anchor_waterfeature','anchor_waterfeature2']){
  const a=group.getObjectByName(name);if(!pop||!a)continue;
  const p0=a.position.clone();p0.y=.042;
  const dir=new THREE.Vector3(-p0.x,0,-p0.z).normalize();
  const p2=p0.clone().addScaledVector(dir,.6);p2.y=y;
  const p1=p0.clone().addScaledVector(dir,.28);p1.y=.19;
  const st=new THREE.Mesh(new THREE.TubeGeometry(new THREE.QuadraticBezierCurve3(p0,p1,p2),48,.008,12,false),streamMat);
  st.visible=false;
  const sg=new THREE.BufferGeometry();sg.setAttribute('position',new THREE.BufferAttribute(new Float32Array([p2.x,y+.005,p2.z]),3));
  const sp_=new THREE.Points(sg,new THREE.PointsMaterial({map:dot,size:.2,transparent:true,opacity:.5,depthWrite:false,color:0xffffff}));
  sp_.visible=false;sp_.renderOrder=3;
  group.add(st,sp_);streams.push(st);splashes.push(sp_);
 }
 const stream=streams[0]||null,splash=splashes[0]||null;
 return {surf,y,jets,bubbles,foam,pos,life,src,N,on:false,jetsOn:false,pop,popY:pop?pop.position.y:0,stream,splash,streams,splashes,streamMat};
}


function makeLights(group,anchors,waterY){
 
 const cells=new Map(),v=new THREE.Vector3();
 group.updateMatrixWorld(true);
 group.traverse(o=>{
  if(!o.isMesh||!o.name.startsWith('lens'))return;
  const p=o.geometry.attributes.position;
  for(let i=0;i<p.count;i++){
   v.fromBufferAttribute(p,i).applyMatrix4(o.matrix);
   const k=[Math.round(v.x/.09),Math.round(v.y/.09),Math.round(v.z/.09)].join();
   const c=cells.get(k)||{x:0,y:0,z:0,n:0,pts:[]};c.x+=v.x;c.y+=v.y;c.z+=v.z;c.n++;c.pts.push(v.clone());cells.set(k,c);}
 });
 const lights=[];
 for(const c of cells.values()){
  const ctr=new THREE.Vector3(c.x/c.n,c.y/c.n,c.z/c.n);
  if(ctr.y>waterY)continue;
  const r=Math.max(...c.pts.map(p=>p.distanceTo(ctr)));
  const n=new THREE.Vector3(-ctr.x,0,-ctr.z).normalize();
  const big=r>.03;
  const l=new THREE.PointLight(0x4f9dff,0,big?1.9:.7,2);l.position.copy(ctr).addScaledVector(n,.02);
  l.userData.weight=big?1:.18;group.add(l);lights.push(l);
 }
 return lights;
}


export async function loadSpa({code='743L-230',W,D,H,renderer=null,base='assets/',withWater=true}={}){
 const {file,shell,cabinet}=layoutFor(code);
 const gltf=await loadGLB(assetURL(`${base}lx-spa-${file}.glb`));
 const group=gltf.scene.clone(true);
 const shellMap=photoTexture(`${base}lx-acrylic-${shell}.webp`,renderer);
 
 shellMap.wrapS=shellMap.wrapT=THREE.RepeatWrapping;shellMap.repeat.set(5,5);
 const {M}=dress(group,{shellMap,cabinet,renderer,base});

 const anchors={};
 for(const o of [...group.children]){
  if(!o.name.startsWith('anchor_'))continue;
  anchors[o.name.slice(7)]=o.position.clone();
  o.visible=false;
 }
 
 const box0=new THREE.Box3().setFromObject(group);
 const size0=box0.getSize(new THREE.Vector3());
 const contact=new THREE.Mesh(
  new THREE.PlaneGeometry(size0.x*1.5,size0.z*1.5),
  new THREE.MeshBasicMaterial({map:contactTexture(),transparent:true,opacity:.72,depthWrite:false,color:0x000000}));
 contact.rotation.x=-Math.PI/2;contact.position.y=box0.min.y+.004;contact.renderOrder=-1;
 group.add(contact);
 
 
 const water=withWater?makeWater(group,M):null;
 if(!withWater)group.traverse(o=>{if(o.isMesh&&/^water_/.test(o.name))o.visible=false;});
 
 const caus=water?causticShell(M.acrylic,water.y):null;
 const lights=makeLights(group,anchors,water?water.y:-.12);
 const box=new THREE.Box3().setFromObject(group);
 const size=box.getSize(new THREE.Vector3());
 const height=-box.min.y;                       // cabinet base sits below the rim
 group.position.y=height;
 if(caus)caus.uWaterY.value+=height;          // the shader works in world space
 group.userData={W:W||size.x,D:D||size.z,H:H||height,rimY:height,anchors,M,water,lights,caus,evening:0,eveningTo:0,
  anchor:key=>(anchors[key]||anchors.footwell||new THREE.Vector3()).clone()};
 return group;
}


export function setWater(spa,{on,jets=on}={}){
 const w=spa?.userData.water;if(!w)return;
 w.on=on;w.jetsOn=on&&jets;w.surf.visible=on;w.bubbles.visible=w.foam.visible=w.jetsOn;
 for(const o of [...w.streams,...w.splashes])o.visible=on;
 if(w.pop)w.pop.position.y=w.popY+(on?.03:0);           // the nozzle pops up when it runs
}

export function setEvening(spa,on){if(spa)spa.userData.eveningTo=on?1:0;}


export function tickSpa(spa,t,dt){
 const u=spa?.userData;if(!u)return false;
 let busy=false;
 u.evening+=(u.eveningTo-u.evening)*Math.min(1,dt*2.2);
 if(Math.abs(u.evening-u.eveningTo)<.002)u.evening=u.eveningTo;else busy=true;
 const e=u.evening;
 u.M.lens.emissiveIntensity=.08+e*5.5;
 u.M.keypad.emissiveIntensity=.05+e*.5;
 if(u.water&&u.water.streamMat)u.water.streamMat.emissiveIntensity=e*1.4;
 for(const l of u.lights)l.intensity=e*(u.water&&u.water.on?4.2:2)*(l.userData.weight||1);
 const w=u.water;
 if(u.caus){
  const want=w&&w.on?(w.jetsOn?1:.6):0;
  u.caus.uCausOn.value+=(want-u.caus.uCausOn.value)*Math.min(1,dt*3);
  u.caus.uCausT.value=t*(w&&w.jetsOn?1.6:.7);
  u.caus.uCausCol.value.setRGB(1,.98,.92).lerp(new THREE.Color(.35,.7,1),e*.85);
 }
 if(w&&w.on){
  busy=true;
  const k=w.jetsOn?1:.35;
  w.surf.material.normalMap.offset.set(t*.018*k,t*.011*k);
  w.surf.material.clearcoatNormalMap.offset.set(-t*.027*k,t*.02*k);
  w.surf.material.normalScale.setScalar(w.jetsOn?.26:.08);
  w.surf.material.clearcoatNormalScale.setScalar(w.jetsOn?.2:.06);
  
  w.surf.material.attenuationColor.setHex(0xcdeee9).lerp(new THREE.Color(0x3a9fe0),e*.7);
  w.surf.material.attenuationDistance=2.2-e*1.1;
  if(w.jetsOn&&w.jets.length){
   for(let i=0;i<w.N;i++){
    w.life[i]+=dt*(.6+((i*37)%11)/14);
    if(w.life[i]>1)w.life[i]-=1;
    const j=w.jets[w.src[i]],a=w.life[i],s=(i*0.618)%1;
    const drift=.06+a*.18;                         // bubbles leave the jet, then rise
    w.pos[i*3]=j.x*(1-drift)+Math.sin(i+t*3)*.02*a;
    w.pos[i*3+1]=j.y+(w.y-j.y)*Math.min(1,a*1.25)-.002;
    w.pos[i*3+2]=j.z*(1-drift)+Math.cos(i*1.3+t*2.6)*.02*a+(s-.5)*.03;
   }
   w.bubbles.geometry.attributes.position.needsUpdate=true;
   w.foam.material.opacity=.22+.08*Math.sin(t*3.1);
  }
  if(w.splashes.length){w.splashes.forEach((sp_,i)=>sp_.material.opacity=.42+.15*Math.sin(t*9.3+i*2)+.08*Math.sin(t*23+i));
  }
 }
 return busy;
}

export function roundedRect(w,d,r){
 const s=new THREE.Shape(),x=-w/2,y=-d/2;
 s.moveTo(x+r,y);s.lineTo(x+w-r,y);s.quadraticCurveTo(x+w,y,x+w,y+r);
 s.lineTo(x+w,y+d-r);s.quadraticCurveTo(x+w,y+d,x+w-r,y+d);
 s.lineTo(x+r,y+d);s.quadraticCurveTo(x,y+d,x,y+d-r);
 s.lineTo(x,y+r);s.quadraticCurveTo(x,y,x+r,y);
 return s;
}

export function outline(kind,w,d,r){
 if(kind==='round'){const s=new THREE.Shape();s.absarc(0,0,w/2,0,Math.PI*2,false);return s;}
 return roundedRect(w,d,kind==='square'?.02:r);
}


export function cabinetGrain(){
 const c=document.createElement('canvas');c.width=1024;c.height=256;const g=c.getContext('2d');
 g.fillStyle='#5b534a';g.fillRect(0,0,1024,256);
 for(let x=0;x<1024;x+=2){const v=Math.random()*26-13,board=(Math.floor(x/128)%2)*7;
  g.fillStyle=`rgb(${99+v+board},${90+v+board},${80+v+board})`;g.fillRect(x,0,2,256);}
 g.strokeStyle='rgba(0,0,0,.38)';g.lineWidth=3;
 for(let x=0;x<1024;x+=128){g.beginPath();g.moveTo(x,0);g.lineTo(x,256);g.stroke();}
 g.fillStyle='rgba(255,255,255,.08)';for(let x=3;x<1024;x+=128)g.fillRect(x,0,2,256);
 const t=new THREE.CanvasTexture(c);t.colorSpace=THREE.SRGBColorSpace;t.wrapS=t.wrapT=THREE.RepeatWrapping;t.repeat.set(2.4,1);
 return t;
}


function contactTexture(){
 const c=document.createElement('canvas');c.width=c.height=256;const g=c.getContext('2d');
 const grad=g.createRadialGradient(128,128,20,128,128,122);
 grad.addColorStop(0,'rgba(0,0,0,.95)');grad.addColorStop(.52,'rgba(0,0,0,.72)');
 grad.addColorStop(.78,'rgba(0,0,0,.22)');grad.addColorStop(1,'rgba(0,0,0,0)');
 g.fillStyle=grad;g.fillRect(0,0,256,256);
 const t=new THREE.CanvasTexture(c);t.colorSpace=THREE.SRGBColorSpace;return t;
}

function glowTexture(){
 const c=document.createElement('canvas');c.width=c.height=256;const g=c.getContext('2d');
 const grad=g.createRadialGradient(128,128,10,128,128,128);
 grad.addColorStop(0,'rgba(190,210,225,.5)');grad.addColorStop(.55,'rgba(150,175,195,.14)');grad.addColorStop(1,'rgba(0,0,0,0)');
 g.fillStyle=grad;g.fillRect(0,0,256,256);
 return new THREE.CanvasTexture(c);
}

export function studioEnvironment(renderer){
 const env=new THREE.Scene(),pm=new THREE.PMREMGenerator(renderer);
 
 env.add(new THREE.Mesh(new THREE.BoxGeometry(22,13,22),new THREE.MeshBasicMaterial({color:0x6a727c,side:THREE.BackSide})));
 const box=(w,h,x,y,z,i,c=0xffffff)=>{const mm=new THREE.Mesh(new THREE.PlaneGeometry(w,h),new THREE.MeshBasicMaterial({color:new THREE.Color(c).multiplyScalar(i),side:THREE.DoubleSide}));mm.position.set(x,y,z);mm.lookAt(0,0,0);env.add(mm);};
 box(9,3.4,-5,5.8,3,5.2,0xfff4e8);box(7,7,6.5,2.2,-6,2.4,0xe4f0ff);box(13,1.4,0,-1,9.5,1.3);
 
 box(14,1.1,0,6.4,1.5,6.0);box(1.2,9,-7,3,-2,2.2,0xffffff);
 
 box(20,9,0,3.5,-10.5,1.15,0xeef3f8);box(20,9,0,3.5,10.5,.95,0xf3efe8);
 box(20,20,0,6.4,0,1.25,0xf6f8fb);
 const t=pm.fromScene(env,.04).texture;pm.dispose();
 return t;
}


const cache=new Map();
export function photoTexture(url,renderer,data=false){
 const key=url+(data?'|data':'');
 if(cache.has(key))return cache.get(key);
 let done;
 const ready=new Promise(res=>{done=res;});
 const t=new THREE.TextureLoader().load(assetURL(url),()=>done(t),undefined,()=>done(t));
 t.colorSpace=data?THREE.NoColorSpace:THREE.SRGBColorSpace;
 t.wrapS=t.wrapT=THREE.ClampToEdgeWrapping;
 if(renderer)t.anisotropy=renderer.capabilities.getMaxAnisotropy();
 
 t.userData.ready=ready;
 cache.set(key,t);return t;
}


export function photoTextureReady(url,renderer,data=false){
 const t=photoTexture(url,renderer,data);
 return t.image&&t.image.width?Promise.resolve(t):(t.userData.ready||Promise.resolve(t));
}
